import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { number, object, SchemaOf } from 'yup';

interface ArticleAmountValidationHook {
  validate: () => SchemaOf<{
    amount?: number;
  }>;
}

export const useArticleAmountValidation = (): ArticleAmountValidationHook => {
  const { t } = useTranslation();
  const validate = useCallback(
    () => object().shape({
      amount: number()
        .integer()
        .typeError(t('validationRules.typeError'))
        .required(t('validationRules.required')),
    }),
    [t],
  );

  return {
    validate,
  };
};
